module.exports = __webpack_public_path__ + "static/media/instagram.bd66ffe6.svg";